export default __webpack_public_path__ + "locales/pt/SocialAuthWelcomeDialog.json?hash=c0513b2984de4c4af69493333eb87b2d";